"use client";

import * as DialogPrimitive from "@radix-ui/react-dialog";
import Overlay from "./overlay";
import Trigger from "./trigger";
import Content from "./content";
import Footer from "./footer";
import Header from "./header";

const Root = DialogPrimitive.Root;
const Portal = DialogPrimitive.Portal;
const Close = DialogPrimitive.Close;
const Title = DialogPrimitive.Title;
const Description = DialogPrimitive.Description;

export {
  Root,
  Portal,
  Overlay,
  Trigger,
  Close,
  Content,
  Header,
  Footer,
  Title,
  Description,
};
